import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import moment from 'moment';

const useOperate = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [scheduleList, setScheduleList] = useState<ScheduleListDto[]>([]);

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.operate.list, location.search],
    () =>
      fetcher.operate.postScheduleList({
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : moment().format('YYYY-MM-DD').toString(),           
        biz: searchParams.biz ? String(searchParams.biz) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '',  
        cm: searchParams.cm ? String(searchParams.cm) : '',  
        op: searchParams.op ? String(searchParams.op) : '',  
        lecturer: searchParams.lecturer ? String(searchParams.lecturer) : '',  
        status: searchParams.status ? String(searchParams.status) : '',  
        place: searchParams.place ? String(searchParams.place) : '',  
      }), 
    {
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setScheduleList(res.result?res.result.list:[]);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { scheduleList, refetch };
};

export default useOperate;
